import { render, staticRenderFns } from "./LegalNotices.vue?vue&type=template&id=3ac44154&scoped=true&"
import script from "./LegalNotices.vue?vue&type=script&lang=js&"
export * from "./LegalNotices.vue?vue&type=script&lang=js&"
import style0 from "./LegalNotices.vue?vue&type=style&index=0&id=3ac44154&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac44154",
  null
  
)

export default component.exports